import { render } from "./modal-barcode.html?vue&type=template&id=6ad37ae0&scoped=true&ts=true"
import script from "./modal-barcode.vue?vue&type=script&lang=ts"
export * from "./modal-barcode.vue?vue&type=script&lang=ts"

import "./modal-barcode.scss?vue&type=style&index=0&id=6ad37ae0&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad37ae0"]])

export default __exports__